/* eslint-disable max-len */

// options: 0: désactivé / 1: par capture photo / 2: vidéo
export const proctoringTypeOptions = [
  {
    label: 'Désactivé',
    value: 0,
  },
  {
    label: 'Par capture photo',
    value: 1,
  },
  {
    label: 'Par vidéo',
    value: 2,
  },
];

// options: 0: null / 1: activé par Evaluo --> logs des actions des étudiants
export const secureTypeId = [
  {
    label: 'Pas de sécurité',
    value: 0,
  },
  {
    label: 'Activé par Evaluo',
    value: 1,
  },
];

// types de sécurisation: 1: notifications aux surveillants / 2: message d'alerte sans blocage / 3: blocage automatique
export const secureLevelId = [
  {
    label: 'Notification aux surveillants',
    value: 1,
  },
  {
    label: 'Message d\'alerte sans blocage',
    value: 2,
  },
  {
    label: 'Blocage automatique',
    value: 3,
  },
];

// 0: rien / 1: Plagio
export const plagiarismType = [
  {
    label: 'Désactivé',
    value: 0,
  },
  {
    label: 'Plagio',
    value: 1,
  },
];
